import { getFunctions, httpsCallable } from 'firebase/functions';

const PIXEL_ID = '1451317539518995';

function norm(v) { return String(v || '').trim().toLowerCase(); }
function normalizePhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (digits.startsWith('56') && digits.length > 9) return `+${digits}`;
  if (digits.startsWith('9') && digits.length === 9) return `+56${digits}`;
  if (digits.length === 8) return `+569${digits}`;
  return digits ? `+56${digits}` : '';
}
function splitName(full) {
  const parts = String(full || '').trim().split(/\s+/);
  return { first: parts[0] || '', last: parts.slice(1).join(' ') || '' };
}

export function getMetaFbq() {
  return typeof window !== 'undefined' ? window.fbq : null;
}

/**
 * Limpia un payload para enviar a Meta.
 * - Solo permite datos del tutor (owner). Nunca del usuario logueado de la plataforma.
 * - Nunca envía IP ni user-agent ni datos de identidad de la plataforma.
 * - Omite campos sensibles de la mascota/clínica/profesionales.
 */
export function buildOwnerPayload(owner = {}) {
  const { first, last } = splitName(owner.name || owner.nombre);
  const ext = owner.rut || owner.rutTutor || owner.ownerRut || owner.documento || owner.ownerId || owner.id || '';
  return {
    external_id: norm(ext),
    first_name: norm(first),
    last_name: norm(last),
    phone: normalizePhone(owner.celular || owner.phone || owner.telefono || owner.ownerPhone),
    email: norm(owner.mail || owner.email || owner.correo || owner.contact),
  };
}

export function buildMetaPayload({ eventName, value, currency = 'CLP', owner = {}, itemName = '', contentIds = [], eventId = '' }) {
  const payload = {
    event_id: eventId,
    value: Number(value) || 0,
    currency,
    content_name: itemName || undefined,
    content_ids: Array.isArray(contentIds) && contentIds.length ? contentIds : undefined,
    content_type: 'product',
    ...buildOwnerPayload(owner),
  };
  Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);
  return payload;
}

/**
 * Envía un evento por el browser Pixel del tutor (solo flujos públicos).
 * Nunca se usa desde módulos internos de la plataforma para no exponer la IP
 * del usuario logueado.
 */
export function trackMetaPixel({ eventName, payload }) {
  const fbq = getMetaFbq();
  if (!fbq) return false;
  try {
    fbq('trackSingle', PIXEL_ID, eventName, payload, { eventID: payload.event_id });
    return true;
  } catch (e) {
    console.warn('Meta Pixel track error:', e);
    return false;
  }
}

/**
 * Envía un evento a Meta Conversions API desde una Cloud Function.
 * Ideal para eventos generados por usuarios de la plataforma (agenda, caja,
 * presupuestos) porque no expone IP ni identidad del usuario logueado.
 */
let _trackServer;
export async function trackMetaEventServer({ eventName, value, currency = 'CLP', owner, itemName, contentIds, eventId }) {
  try {
    if (!_trackServer) {
      _trackServer = httpsCallable(getFunctions(), 'sendMetaEvent');
    }
    const payload = buildMetaPayload({ eventName, value, currency, owner, itemName, contentIds, eventId });
    await _trackServer({ eventName, ...payload });
    return true;
  } catch (e) {
    console.warn('Meta server event error:', e);
    return false;
  }
}

export const PIXEL_ID_HCV = PIXEL_ID;
